module.exports = __webpack_public_path__ + "checklist.71ba9aab55e885bbc751943b2e669559.svg";